import { render, staticRenderFns } from "./EditTextNumerosConfig.vue?vue&type=template&id=5974f1b4&scoped=true"
import script from "./EditTextNumerosConfig.vue?vue&type=script&lang=js"
export * from "./EditTextNumerosConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5974f1b4",
  null
  
)

export default component.exports